import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import setMeta from '../../statement/actions/set-meta'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'
import { IStatement, StatementMeta } from '../../../model/statement'
import statementStore from '../../statement/statement-store'

export default async function fetchStatements(context: BareActionContext<ConvoState, RootState>, convo: IConvo) {
  convoUtils.convoService.getStatements(convo).then((statements: IStatement[]) => {
    for (let i=0; i<statements.length; i++) {
      if (statementStore.state.statementMap.has(statements[i].id as number)) {
        statements[i] = statementStore.state.statementMap.get(statements[i].id as number) as IStatement
      } else {
        statementStore.state.statementMap.set(statements[i].id as number, statements[i])
        statements[i].meta = new StatementMeta()
      }
    }
    convoStore.commitSetStatements({ convo: convo, statements: statements })
    for(let i=0; i<statements.length; i++) {
      if (!statements[i].isMetaSet) {
        statementStore.dispatchSetMeta(statements[i])
      }
    }
  })

  return
}
